<template>
    <section 
        class="o-otg-modal-container"
        :style="styles"
    >
        <OOtgModalHeader
            :label="headerLabel"
            class="otg-modal-container-header"
            @onClose="handleClose"
        />
        <section class="otg-modal-container-inner-section">
            <slot />
        </section>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import OOtgModalHeader from '../../organisms/o-otg-modal-header';

export default {
    name: 'OOtgModalContainer',
    components: {
        OOtgModalHeader
    },
    props: {
        headerLabel: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters(['getMapConfigProp']),
        styles() {
            return this.getMapConfigProp('components.OOtgModalContainer.styles') || null;
        }
    },
    setup(props, { emit }) {
        function handleClose() {
            emit('onClose');
        }

        return {
            handleClose
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />